import React from "react";
import moment from "moment-timezone";
import { DATE_FORMAT } from "../constants/index";

export interface DateDisplayProps {
	//The string (to be converted into a Date) or Date to be displayed
	date: string | Date;

	//Size of font for date to be displayed in.
	fontSize?: number;
}

/**
 * Accepts a string or Date that is then displayed using the centralized
 * date time format: DATE_FORMAT. should display UTC time on the page and
 * the local time in the title upon mouse over.
 * @param props
 */
export const DateDisplay = (props: DateDisplayProps) => {
	return (
		<span
			style={{ fontSize: props.fontSize || 12 }}
			data-testid="date-display"
			title={moment(props.date).local().format(DATE_FORMAT)}
		>
			{moment(props.date).format(DATE_FORMAT)}
		</span>
	);
};
